<div class="clover-page">
  <app-banner-typeb
    [img]="'banner-clover.png'"
    [title]="'Clover'"
    [description]="
      'Praticidade na gestão e uma experiência de compra que encanta seus clientes'
    "
    [cta]="'Conheça'"
    [url]="'/clover#dobra'"
    [className]="['justify-content-start', 'align-items-end']"
    [positionContain]="true"
  />

  <main id="dobra" class="container">
    <section class="componente-text-img">
      <div class="container">
        <header class="isMobile">
          <span class="mark-black">Lançamento</span>
          <h2>Descubra o poder do mundo Clover</h2>
          <div class="col-lg-9 mt-4">
            <p>
              A Clover entrou para a família de soluções da azulzinha da CAIXA
              para simplificar sua rotina, revolucionar sua operação e encantar
              os seus clientes com uma experiência de pagamentos inovadora!
            </p>

            <p>
              Com a tecnologia de ponta e o design moderno, você pode ter um PDV
              compacto com a Clover Mini ou um dispositivo móvel completo com a
              Clover Flex para fazer muito mais.
            </p>
          </div>
        </header>
        <app-block-text-img [left]="true">
          <ng-container contentText>
            <header>
              <span class="mark-black">Lançamento</span>
              <h2>Descubra o poder do mundo Clover</h2>
              <div class="col-lg-9 mt-4">
                <p>
                  A Clover entrou para a família de soluções da azulzinha da
                  CAIXA para simplificar sua rotina, revolucionar sua operação e
                  encantar os seus clientes com uma experiência de pagamentos
                  inovadora!
                </p>

                <p>
                  Com a tecnologia de ponta e o design moderno, você pode ter um
                  PDV compacto com a Clover Mini ou um dispositivo móvel
                  completo com a Clover Flex para fazer muito mais.
                </p>
              </div>
            </header>
            <ul class="col-lg-9">
              <li>
                <img [lazyLoad]="'assets/img/seta-direita.png'" alt="" /><span
                  ><span class="mark-blue">Gestão fácil:</span> tudo em uma
                  única plataforma;</span
                >
              </li>
              <li>
                <img [lazyLoad]="'assets/img/seta-direita.png'" alt="" /><span
                  ><span class="mark-blue">Mais economia:</span> menos sistemas,
                  mais lucro;</span
                >
              </li>

              <li>
                <img [lazyLoad]="'assets/img/seta-direita.png'" alt="" /><span
                  ><span class="mark-blue">Integração rápida:</span> conecte
                  softwares (ERP e CRM) e pagamentos sem complicação.</span
                >
              </li>
            </ul>
          </ng-container>
          <ng-container contentImg>
            <div class="container-img">
              <div class="bg-img-tonewo"></div>
              <div class="img-one">
                <picture>
                  <source
                    media="(max-width: 765px)"
                    srcset="assets/img/maquinas/clover/maquina-clover.png"
                  />
                  <img
                    class="img-fluid"
                    src="assets/img/maquinas/clover/maquina-clover.png"
                    alt=""
                  />
                </picture>
              </div>
            </div>
          </ng-container>
        </app-block-text-img>
      </div>
    </section>
    <section>
      <div class="componente-text-img">
        <div class="container">
          <header class="isMobile">
            <h2>Por que escolher a Clover?</h2>
          </header>
          <app-block-text-img>
            <ng-container contentText>
              <swiper
                [slidesPerGroup]="1"
                [loop]="false"
                [loopFillGroupWithBlank]="true"
                [breakpoints]="myConfig"
                [navigation]="true"
                class="mySwiper"
              >
                <ng-template class="relative" swiperSlide>
                  <div class="container-text-slide col-md-12">
                    <header>
                      <h2>Por que escolher a Clover?</h2>
                    </header>
                    <ul class="col-lg-9 mt-4">
                      <p class="mark-blue fw-bold">Integração simplificada</p>
                      <ul class="list-disc">
                        <li>Ferramentas que facilitam a integração;</li>
                        <li>Documentação completa e estruturada;</li>
                        <li>
                          Suporte rápido e remoto para automação comercial.
                        </li>
                      </ul>
                      <p class="mark-blue fw-bold">Diversidade de pagamentos</p>
                      <ul class="list-disc">
                        <li>Mais de 240 bandeiras com a solução SiTef;</li>
                        <li>Recebimento em dinheiro;</li>

                        <li>Venda por aproximação.</li>
                      </ul>
                      <p class="mark-blue fw-bold">Design e inovação</p>
                      <ul class="list-disc">
                        <li>
                          Diversidade de funções, incluindo autoatendimento;
                        </li>
                        <li>Padronização da sua frente de caixa.</li>
                      </ul>
                    </ul>
                  </div>
                </ng-template>
                <ng-template class="relative" swiperSlide>
                  <div class="container-text-slide">
                    <header>
                      <h2>Por que escolher a Clover?</h2>
                    </header>
                    <ul class="col-lg-9 mt-4">
                      <p class="mark-blue fw-bold">
                        Interface e navegação intuitiva
                      </p>
                      <ul class="list-disc">
                        <li>Usabilidade Android;</li>
                        <li>Experiência de uso simplificada;</li>
                        <li>Calculadora integrada.</li>
                      </ul>
                      <p class="mark-blue fw-bold">Gestão do negócio</p>
                      <ul class="list-disc">
                        <li>Cadastro de clientes;</li>
                        <li>Cadastro de funcionários e controle de turnos;</li>
                        <li>Gestão de fluxo de caixa;</li>
                        <li>
                          Portal para acompanhamento das transações online.
                        </li>
                      </ul>
                      <p class="mark-blue fw-bold">Acesso remoto</p>
                      <ul class="list-disc">
                        <li>Controle de ferramentas a distância;</li>
                        <li>Suporte remoto dedicado e sempre disponível.</li>
                      </ul>
                    </ul>
                  </div>
                </ng-template>
              </swiper>
            </ng-container>
            <ng-container contentImg>
              <div class="container-img">
                <div class="bg-img-two"></div>
                <div class="img-two pt-4">
                  <picture>
                    <source
                      media="(max-width: 765px)"
                      srcset="assets/img/maquinas/clover/maquina-clover-2.png"
                    />
                    <img
                      class="img-fluid"
                      src="assets/img/maquinas/clover/maquina-clover-2.png"
                      alt=""
                    />
                  </picture>
                </div>
              </div>
            </ng-container>
          </app-block-text-img>
          <div class="mt-2">
            <a
              class="d-flex justify-content-center align-items-center gap-2 mark-blue"
              href="/clover#escolha"
              >Saiba mais
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.1694 7.84732C14.4698 7.13342 13.7509 6.44194 13.0754 5.7002C11.9605 4.47713 10.8746 3.22263 9.77574 1.9825C9.51951 1.69424 9.4159 1.36106 9.52594 0.964142C9.62715 0.600453 9.86008 0.396643 10.1854 0.326599C10.4842 0.262841 10.7332 0.380458 10.9444 0.619325C12.8095 2.73321 14.6754 4.84529 16.5421 6.95827C16.9269 7.3938 17.3165 7.82306 17.7004 8.25949C18.1093 8.72465 18.0948 9.31014 17.6867 9.75465C16.3678 11.1914 15.0538 12.6336 13.7389 14.0758C12.8151 15.0897 11.8946 16.1071 10.9693 17.1191C10.5653 17.561 10.0882 17.578 9.72836 17.1793C9.38136 16.795 9.3974 16.2283 9.77813 15.7856C11.4705 13.8172 13.1654 11.8515 14.861 9.88667C14.869 9.89026 14.7172 9.95043 14.5839 9.95043C10.0713 9.94683 5.55959 9.94773 1.04704 9.94683C0.875147 9.94683 0.703226 9.9621 0.534547 9.88487C0.15221 9.70976 -0.0485808 9.32182 0.0100551 8.84319C0.0598554 8.4337 0.349806 8.12301 0.736963 8.07722C0.882348 8.06015 1.03014 8.06463 1.17713 8.06463C5.64952 8.06463 10.1211 8.06463 14.5935 8.06463H15.0216C15.0706 7.99279 15.1196 7.92096 15.1686 7.84912L15.1694 7.84732Z"
                  fill="#005FAF"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
    <section id="escolha">
      <div class="container-compare row">
        <header class="text-center">
          <h2>Compare e escolha a sua Clover</h2>
        </header>
        <div class="card-clover col-md-5 col-12">
          <div class="text-center">
            <img src="assets/img/maquinas/clover/clover-flex.jpg" alt="" />
          </div>
          <div>
            <h2 class="mb-4">Clover Flex</h2>
            <p>
              No balcão, na mesa ou em qualquer lugar, atenda seus clientes com
              mais rapidez e conveniência com a Clover Flex, uma solução móvel
              completa de pagamentos com impressora integrada.
            </p>
          </div>
          <div>
            <div>
              <span class="mark-black">Por que escolher a Clover Flex?</span>
              <ul>
                <li>
                  <img src="assets/img/icons/icon-seguranca.svg" alt="" />
                  Segura: Criptografia de ponta a ponta para proteger seus
                  dados;
                </li>

                <li>
                  <img src="assets/img/icons/icon-touch.svg" alt="" />
                  Completa: Aceita Pix, QR Code, cartões (chip, tarja e
                  aproximação), carteiras digitais e link de pagamento;
                </li>
                <li>
                  <img src="assets/img/icons/icon-wifi.svg" alt="" />
                  Sempre conectada: Wi-Fi, 4G, 3G e 2G para um sinal estável
                  onde você estiver;
                </li>

                <li>
                  <img src="assets/img/icons/icon-batery.svg" alt="" />
                  Mobilidade sem preocupação: Bateria de longa duração e recarga
                  prática via base ou USB-C;
                </li>

                <li>
                  <img src="assets/img/icons/e-mail.svg" alt="" />
                  Mais comodidade: Impressão de recibos e envio digital por SMS
                  ou e-mail;
                </li>
                <li>
                  <img src="assets/img/icons/icon-time.svg" alt="" />
                  Rápida e confiável: Processador Qualcomm Snapdragon™ e mais
                  memória para desempenho superior.
                </li>
              </ul>
            </div>
            <div>
              <span class="mark-black">Ficha técnica</span>
              <ul>
                <li>
                  <img [lazyLoad]="'assets/img/seta-direita.png'" alt="" />
                  Tela: Colorida e sensível ao toque (5,99");
                </li>
                <li>
                  <img [lazyLoad]="'assets/img/seta-direita.png'" alt="" />
                  Câmera: Leitura de código de barras e QR Code (1D/2D);
                </li>
                <li>
                  <img [lazyLoad]="'assets/img/seta-direita.png'" alt="" />
                  Segurança: Proteção total com criptografia;
                </li>
                <li>
                  <img [lazyLoad]="'assets/img/seta-direita.png'" alt="" />
                  Acessório: Capa de silicone para maior durabilidade;
                </li>
                <li>
                  <img [lazyLoad]="'assets/img/seta-direita.png'" alt="" />
                  Carregamento: recarga de bateria por indução.
                </li>
              </ul>
            </div>
          </div>
          <app-button
            text="Peça a sua Clover Flex"
            href="peca-azulzinha"
          ></app-button>
        </div>
        <div class="card-clover col-md-5 col-12">
          <div>
            <div class="text-center container-img">
              <img src="assets/img/maquinas/clover/clover-mini.jpg" alt="" />
            </div>
            <div>
              <div>
                <h2 class="mb-4">Clover Mini</h2>
                <p>
                  Pequena no tamanho, gigante no desempenho, a Clover Mini é um
                  PDV compacto que cabe em qualquer espaço, facilita a gestão do
                  seu negócio e melhora a experiência dos seus clientes.
                </p>
              </div>
              <div>
                <div>
                  <span class="mark-black"
                    >Por que escolher a Clover Mini?</span
                  >
                  <ul>
                    <li>
                      <img src="assets/img/icons/icon-seguranca.svg" alt="" />
                      Segura: Criptografia de ponta a ponta para proteger seus
                      dados e transações;
                    </li>
                    <li>
                      <img src="assets/img/icons/icon-touch.svg" alt="" />
                      Completa: Aceita Pix, QR Code, cartões (chip, tarja e
                      aproximação), carteiras digitais e link de pagamento;
                    </li>
                    <li>
                      <img src="assets/img/icons/icon-wifi.svg" alt="" />
                      Sempre conectada: Wi-Fi, 4G e internet via cabo de rede
                      para estabilidade total;
                    </li>
                    <li>
                      <img src="assets/img/icons/e-mail.svg" alt="" />
                      Mais comodidade: Impressão de recibos e envio digital por
                      SMS ou e-mail;
                    </li>
                    <li>
                      <img src="assets/img/icons/icon-time.svg" alt="" />
                      Compacta e poderosa: Desempenho de ponta com processador
                      Qualcomm 660.
                    </li>
                  </ul>
                </div>
                <div class="margin-top-md">
                  <span class="mark-black">Ficha técnica</span>
                  <ul>
                    <li>
                      <img
                        [lazyLoad]="'assets/img/seta-direita.png'"
                        alt=""
                      />Tela touch: tela de 8” sensível ao toque para
                      autoatendimento e conferência da compra;
                    </li>
                    <li>
                      <img
                        [lazyLoad]="'assets/img/seta-direita.png'"
                        alt=""
                      />Câmera: Leitura de código de barras e QR Code (1D/2D);
                    </li>
                    <li>
                      <img
                        [lazyLoad]="'assets/img/seta-direita.png'"
                        alt=""
                      />Segurança: Proteção total com criptografia;
                    </li>
                    <li>
                      <img
                        [lazyLoad]="'assets/img/seta-direita.png'"
                        alt=""
                      />Fonte de alimentação: Cabo.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <app-button
            text="Peça a sua Clover Mini"
            href="peca-azulzinha"
          ></app-button>
        </div>
      </div>
    </section>
    <section
      id="meuElemento"
      class="container-aplicativos row d-flex align-items-start justify-content-between"
    >
      <div class="col-lg-4 d-flex justify-content-center">
        <img
          class="img-fluid"
          src="assets/img/maquinas/clover/maquina-clover-3.png"
          alt=""
        />
      </div>
      <div class="col-lg-8">
        <header>
          <h2>Aplicativos que já vêm na Clover</h2>
        </header>
        <div class="tabs">
          <div class="tab-header">
            <div
              class="button d-flex gap-1"
              [ngClass]="{ active: activeTab === 'gratuitos' }"
              (click)="setActiveTab('gratuitos')"
            >
              <span>APLICATIVOS GRATUITOS</span>
            </div>
            <div
              class="button"
              [ngClass]="{ active: activeTab === 'automacoes' }"
              (click)="setActiveTab('automacoes')"
            >
              AUTOMAÇÕES COMERCIAIS
            </div>
          </div>

          <div class="tab-content">
            <div *ngIf="activeTab === 'gratuitos'">
              <!-- Conteúdo da aba "Aplicativos Gratuitos" -->
              <div class="list-aplicativos">
                <div
                  class="aplicativos_column"
                  [ngClass]="{ active: activeModalItem }"
                >
                  <div
                    class="aplicativos-item"
                    *ngFor="let categoria of aplicativosGratuitos"
                  >
                    <p style="font-size: 16px">{{ categoria.title }}</p>
                    <ul class="list-apps">
                      <li
                        *ngFor="let item of categoria.items"
                        class="has-submenu"
                        [ngClass]="{
                          disabled: item.status === 'disabled',
                          disabledActive: item.status === 'disabled-active'
                        }"
                        (click)="setActiveModal(item)"
                      >
                        <div class="icon-wrapper">
                          <img
                            class="modal-icon"
                            [src]="'assets/img/icons/' + item.img"
                          />
                          {{ item.text }}
                        </div>
                        <img
                          class="seta"
                          src="assets/img/icons/seta-bottom-grey.svg"
                          alt=""
                        />
                      </li>
                    </ul>
                    <!-- Acordion -->
                    <div
                      *ngFor="let item of categoria.items; let key = index"
                      class="accordion"
                      id="accordionExample-{{
                        categoria.title | lowercase | replaceSpaces
                      }}"
                    >
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="p{{ key }}">
                          <button
                            [ngClass]="{
                              disabled: item.status === 'disabled',
                              disabledActive: item.status === 'disabled-active'
                            }"
                            class="accordion-button collapsed gap-3"
                            type="button"
                            [disabled]="item.status === 'disabled'"
                            data-bs-toggle="collapse"
                            attr.data-bs-target="#c{{
                              categoria.title | lowercase | replaceSpaces
                            }}-{{ key }}"
                            aria-expanded="false"
                            attr.aria-controls="c{{
                              categoria.title | lowercase | replaceSpaces
                            }}-{{ key }}"
                          >
                            <img
                              style="max-width: 25px"
                              [src]="'assets/img/icons/' + item.img"
                              alt=""
                            />
                            {{ item.text }}
                          </button>
                        </h2>
                        <div
                          id="c{{
                            categoria.title | lowercase | replaceSpaces
                          }}-{{ key }}"
                          class="accordion-collapse collapse"
                          attr.aria-labelledby="p{{ key }}"
                        >
                          <div class="accordion-body">
                            <p>{{ item.body.paragraph }}</p>
                            <p>Benefícios</p>
                            <ul>
                              <li
                                *ngFor="let beneficio of item.body.beneficios"
                                [innerHTML]="beneficio"
                              ></li>
                            </ul>
                            <div
                              class="d-flex align-items-center justify-content-center mt-5"
                            >
                              <img
                                *ngIf="item.body.img"
                                class="img-modal img-fluid"
                                [src]="
                                  'assets/img/maquinas/clover/' + item.body.img
                                "
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Modais -->
                <div
                  *ngFor="let item of itemAplicativosFlattened"
                  class="aplicativos-modal"
                  [ngClass]="{ active: activeModalItem === item }"
                >
                  <header
                    (click)="setActiveModal(null)"
                    class="d-flex w-100 justify-content-between"
                  >
                    <div class="d-flex align-items-center gap-2">
                      <img
                        class="modal-icon"
                        [src]="'assets/img/icons/' + item.img"
                      />
                      <p>{{ item.text }}</p>
                    </div>
                    <div>
                      <img src="assets/img/icons/seta-cima.svg" alt="" />
                    </div>
                  </header>
                  <p>{{ item.body.paragraph }}</p>
                  <div class="mt-4">
                    <span>Benefícios</span>
                    <ul>
                      <li
                        *ngFor="let beneficio of item.body.beneficios"
                        [innerHTML]="beneficio"
                      ></li>
                    </ul>
                    <div
                      class="d-flex align-items-center justify-content-center mt-5"
                    >
                      <img
                        *ngIf="item.body.img"
                        class="img-modal img-fluid"
                        [src]="'assets/img/maquinas/clover/' + item.body.img"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="activeTab === 'automacoes'">
              <!-- Conteúdo da aba "Automações Comerciais" -->
              <div class="list-aplicativos">
                <div
                  class="aplicativos_column"
                  [ngClass]="{ active: activeModalItem }"
                >
                  <div
                    class="col-md-12 col-12"
                    *ngFor="let categoria of aplicativosComercias"
                  >
                    <div class="aplicativos-item">
                      <p style="font-size: 16px">{{ categoria.title }}</p>
                      <ul class="list-apps">
                        <li
                          *ngFor="let item of categoria.items"
                          class="has-submenu"
                          [ngClass]="{
                            disabled: item.status === 'disabled',
                            disabledActive: item.status === 'disabled-active'
                          }"
                          (click)="setActiveModal(item)"
                        >
                          <div>
                            <img [src]="'assets/img/icons/' + item.img" />
                            {{ item.text }}
                          </div>
                          <img
                            class="seta"
                            src="assets/img/icons/seta-bottom-grey.svg"
                            alt=""
                          />
                        </li>
                      </ul>
                        <!-- Acordion -->
                    <div
                    *ngFor="let item of categoria.items; let key = index"
                    class="accordion"
                    id="accordionExample-{{
                      categoria.title | lowercase | replaceSpaces
                    }}"
                  >
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="p{{ key }}">
                        <button
                          [ngClass]="{
                            disabled: item.status === 'disabled',
                            disabledActive: item.status === 'disabled-active'
                          }"
                          class="accordion-button collapsed gap-3"
                          type="button"
                          [disabled]="item.status === 'disabled'"
                          data-bs-toggle="collapse"
                          attr.data-bs-target="#c{{
                            categoria.title | lowercase | replaceSpaces
                          }}-{{ key }}"
                          aria-expanded="false"
                          attr.aria-controls="c{{
                            categoria.title | lowercase | replaceSpaces
                          }}-{{ key }}"
                        >
                          <img
                            style="max-width: 25px"
                            [src]="'assets/img/icons/' + item.img"
                            alt=""
                          />
                          {{ item.text }}
                        </button>
                      </h2>
                      <div
                        id="c{{
                          categoria.title | lowercase | replaceSpaces
                        }}-{{ key }}"
                        class="accordion-collapse collapse"
                        attr.aria-labelledby="p{{ key }}"
                      >
                        <div class="accordion-body">
                          <p>{{ item.body.paragraph }}</p>
                          <p>Benefícios</p>
                          <ul>
                            <li
                              *ngFor="let beneficio of item.body.beneficios"
                              [innerHTML]="beneficio"
                            ></li>
                          </ul>
                          <div
                            class="d-flex align-items-center justify-content-center mt-5"
                          >
                            <img
                              *ngIf="item.body.img"
                              class="img-modal img-fluid"
                              [src]="
                                'assets/img/maquinas/clover/' + item.body.img
                              "
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                    </div>
                  </div>
                </div>

                <!-- Modais -->
                <div
                  *ngFor="let item of itemAplicativosFlattened"
                  class="aplicativos-modal"
                  [ngClass]="{ active: activeModalItem === item }"
                >
                  <header
                    (click)="setActiveModal(null)"
                    class="d-flex w-100 justify-content-between"
                  >
                    <div class="d-flex align-items-center gap-2">
                      <img [src]="'assets/img/icons/' + item.img" />
                      <p>{{ item.text }}</p>
                    </div>
                    <div>
                      <img src="assets/img/icons/seta-cima.svg" alt="" />
                    </div>
                  </header>
                  <p>{{ item.body.paragraph }}</p>
                  <div class="mt-4">
                    <span>Benefícios</span>
                    <ul>
                      <li
                        *ngFor="let beneficio of item.body.beneficios"
                        [innerHTML]="beneficio"
                      ></li>
                    </ul>
                    <div
                      class="d-flex align-items-center justify-content-center mt-3"
                    >
                      <img
                        class="img-modal img-fluid"
                        [src]="'assets/img/maquinas/clover/' + item.body.img"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="text-center">
        <h2>Contrate aplicativos de automação feitos para o seu negócio</h2>

        <div
          class="d-flex align-items-center flex-wrap content-automacoes justify-content-center"
        >
          <div *ngFor="let img of bandeiras">
            <img [src]="'assets/img/bandeiras/' + img" alt="" />
          </div>
        </div>
      </footer>
    </section>

    <app-carousel
      title="A Clover é ideal para o seu nicho de mercado"
      [cards]="carouselCards"
      cta="Peça a sua Clover"
    ></app-carousel>
    <app-playlist-videos defaultCategory="Clover"> </app-playlist-videos>
  </main>
</div>
<footer>
  <app-promotion-banner
    title="Descubra o poder do mundo Clover com a azulzinha"
    description="Preencha o formulário e receba uma oferta sob medida com as soluções da Clover e as condições exclusivas que só a CAIXA tem para o seu negócio."
    textCta="Peça a sua Clover"
    hrefCta="/peca-azulzinha"
    img="assets/img/mulher-com-maquina-clover.png"
    imgMobile="assets/img/mulher-com-maquina-clover-mb.png"
  ></app-promotion-banner>
</footer>
